import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../logo.svg";
import Search from "./Search";

export default function Navbar() {
	const [isMenuActive, setIsMenuActive] = useState(false);

	return (
		<nav
			className="navbar has-shadow"
			role="navigation"
			aria-label="main navigation">
			<div className="navbar-brand">
				<Link to="/" className="navbar-item">
					<img src={logo} alt="Logo" />
				</Link>
				<a
					role="button"
					className={`navbar-burger burger ${isMenuActive ? "is-active" : ""}`}
					aria-label="menu"
					aria-expanded="false"
					data-target="navbar"
					onClick={() => setIsMenuActive(!isMenuActive)}
					href="#/">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>
			<div
				id="navbar"
				className={`navbar-menu ${isMenuActive ? "is-active" : ""}`}>
				<div className="navbar-start">
					<Link to="/" className="navbar-item">
						Home
					</Link>
					<Link to="/meal-plan" className="navbar-item">
						Meal Plan
					</Link>
					<Link to="/suggestions" className="navbar-item">
						Suggestions
					</Link>
				</div>
				<div className="navbar-end">
					<div className="navbar-item">
						<Search />
					</div>
				</div>
			</div>
		</nav>
	);
}
